import React from "react";
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";
import {isFunction, isNull, isString, isUndefined} from "underscore";

export const ClickableNameCell = ({
  id,
  name,
  action = "view",
  onClick,
  type,
  page,
  pushState,
}) => {
  if (!onClick && (isUndefined(id) || isNull(id))) {
    return null;
  }
  const navigate = useNavigate();
  const whichPage =
    page === false ?
      "" :
      isString(page) ?
        `/${page}` :
        "/overview";

  const handleClick = () => {
    if (isFunction(onClick)) {
      onClick();
    } else {
      navigate(`/${type}/${action}/${id}${whichPage}`, {state: {pushState}});
    }
  };

  return (
    <span onClick={handleClick} style={{cursor: "pointer"}}>
      {name}
    </span>
  );
};

ClickableNameCell.propTypes = {
  id: PropTypes.number,
  action: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func,
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  pushState: PropTypes.object,
  type: PropTypes.string,
};
